// {
//   id: 1,
//   title: "E-Commerce Revolution",
//   genre: "Action/Thriller",
//   description: "A high-octane shopping platform that breaks all conventional rules",
//   technologies: ["React", "Node.js", "MongoDB", "Stripe"],
//   image: "🛒",
//   rating: "PG-13",
//   duration: "3 Months",
//   year: "2024",
//   director: "John Developer",
//   color: "from-red-600 to-red-800",
//   textColor: "text-white"
// },

export const Projects = [
  {
    id: 1,
    title: "Imposteur des Mots",
    genre: "Jeu / Multijoueur",
    description: "Jeu multijoueur en ligne inspiré du principe de « Among Us » appliqué aux mots. Les joueurs reçoivent un mot secret commun, sauf un imposteur qui reçoit un mot similaire. À travers des indices et des discussions, les joueurs doivent identifier l'imposteur avant qu'il ne se fonde dans la masse.",
    technologies: ["HTML", "Javascript", "CSS"],
    image: "🕵️",
    rating: "G",
    duration: "1 Week",
    year: "2025",
    director: "Khalil Mohammad",
    color: "from-teal-600 to-teal-800",
    textColor: "text-white",
    githubLink: "https://imposterdesmots.netlify.app"
  },
  {
    id: 2,
    title: "Mini-site SCRUD",
    genre: "Decouverte/International",
    description: "Mini-site web permettant de gérer une base de données de pays (ajout, modification, suppression, affichage et recherche).",
    technologies: ["HTML", "PHP", "MySQL", "MVC simple"],
    image: "🌍",
    rating: "PG-13",
    duration: "1 Months",
    year: "2025",
    director: "Khalil Mohammad",
    color: "from-red-600 to-red-800",
    textColor: "text-white",
    githubLink: "https://github.com/mo-khalil01/mini-site-SCRUD"
  },
  {
    id: 3,
    title: "Hex",
    genre: "Jeu / Stratégie",
    description: "Jeu de plateau stratégique en deux joueurs sur une grille hexagonale, dans le but de relier deux côtés opposés du plateau. Le jeu implémente une IA utilisant l'algorithme MCTS.",
    technologies: ["Java", "Design Pattern", "Algorithms", "Git"],
    image: "⬡",
    rating: "PG",
    duration: "3 Months",
    year: "2025",
    director: "Group work",
    color: "from-pink-600 to-pink-800",
    textColor: "text-white",
    githubLink: "https://github.com/mo-khalil01/Hex-game"
  },
  {
    id: 4,
    title: "Corewar Simulator",
    genre: "Sci-Fi",
    description: "Projet complexe simulant des combats de programmes dans une machine virtuelle. Intégration d’algorithmes d’optimisation comme le recuit simulé et l’algorithme génétique pour générer de nouveaux programmes.",
    technologies: ["Java", "Systèmes multi-processus", "Algorithmes d'optimisation"],
    image: "🤖",
    rating: "PG-13",
    duration: "3 Months",
    year: "2025",
    director: "Khalil Mohammad",
    color: "from-purple-600 to-purple-800",
    textColor: "text-white",
    githubLink: "https://github.com/mo-khalil01/Corewar-Simulator"
  },
  {
    id: 5,
    title: "Jeu de Blackjack",
    genre: "Thriller/Casino",
    description: "Développement d'un jeu de Blackjack",
    technologies: ["Java", "Swing", "Design Pattern"],
    image: "🃏",
    rating: "18+",
    duration: "3 Months",
    year: "2024",
    director: "Group project",
    color: "from-yellow-500 to-yellow-700",
    textColor: "text-black", 
    githubLink: "https://github.com/mo-khalil01/Jeu-de-Blackjack-en-java"
  },
  {
    id: 6,
    title: "Bataille Navale",
    genre: "Adventure/War",
    description: "Jeu de bataille navale réalisé en Java, basé sur une architecture MVC, avec une interface graphique en Swing et un système d’observation entre la vue et le modèle.",
    technologies: ["Java", "Architecture MVC", "Swing"],
    image: "🚢",
    rating: "PG-13",
    duration: "2 Months",
    year: "2025",
    director: "Khalil Mohammad",
    color: "from-green-600 to-green-800",
    textColor: "text-white",
    githubLink: "https://github.com/mo-khalil01/Bataille-Navale-Java-Swing"
  },
  {
    id: 7,
    title: "To-Do List App",
    genre: "Drama/Productivity",
    description: "Application de gestion de tâches avec authentification utilisateur, stockage en temps réel et interface réactive.",
    technologies: ["React Native", "GraphQL", "Neo4j"],
    image: "📋",
    rating: "PG",
    duration: "2 Months",
    year: "2025",
    director: "Khalil Mohammad",
    color: "from-amber-600 to-amber-800",
    textColor: "text-black",
    githubLink: "https://github.com/mo-khalil01/Todo-App"
  },
  {
    id: 8,
    title: "Jeu de Morpion (Tic-Tac-Toe)",
    genre: "Family/Comedy",
    description: "Implémentation complète d’un jeu de morpion en Java avec une logique d’intelligence simple détectant les “cases menaçantes” pour empêcher l’adversaire de gagner.",
    technologies: ["Java", "Programmation orientée objet", "Factorisation", "Débogage et tests unitaires"],
    image: "🎮",
    rating: "G",
    duration: "2 Months",
    year: "2024",
    director: "Khalil Mohammad",
    color: "from-blue-500 to-blue-700",
    textColor: "text-black",
    githubLink: "https://github.com/mo-khalil01/Jeu-de-morpion"
  },
  
];

export const Skills = [
  {
    category: "Programming Languages",
    icon: "💻",
    skills: ["JavaScript","PHP", "Java", "Python",  "C"]
  },
  {
    category: "Frontend Technologies",
    icon: "🎨",
    skills: ["HTML", "CSS", "React", "Tailwind"]
  },
  {
    category: "Databases",
    icon: "🗄️",
    skills: ["MySQL", "GraphQL", "Neo4j", "MangoDB"]
  },
  {
    category: "Outils & IDEs",
    icon: "🛠️",
    skills: ["Git", "GitHub","PHPMyAdmin", "Visual Studio Code", "IntelliJ", "FileZilla"]
  },
  {
    category: "Concepts & Methodologies",
    icon: "📚",
    skills: ["Programmation orientée objet", "Architecture MVC", "Design Patterns", "Agile/Scrum", "Trello",]
  },
  {
    category: "Systèmes d'exploitation",
    icon: "🖥️",
    skills: ["Windows", "Linux", "Shell"]
  }
];